/**
 * Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: LicenseRef-.amazon.com.-AmznSL-1.0
 * Licensed under the Amazon Software License  http://aws.amazon.com/asl/
 */

// add 2359 - add support for EMR-hail notebook permission entities
/* eslint-disable import/prefer-default-export */
import { types } from 'mobx-state-tree';

import UserIdentifier from '../users/UserIdentifier';

// ==================================================================
// Notebook Permissions
// ==================================================================

const NotebookPermissions = types
  .model('NotebookPermissions', {
    id: types.identifier,
    adminUsers: types.array(UserIdentifier),
    readonlyUsers: types.array(UserIdentifier),
    accessRequestedUsers: types.array(UserIdentifier),
    requestedPermissions: types.array(
      types.model({
        principalIdentifier: UserIdentifier,
        isRead: types.boolean,
        expiry: types.maybeNull(types.string),
      }),
    ),
    permissions: types.array(
      types.model({
        principalIdentifier: UserIdentifier,
        isRead: types.boolean,
        expiry: types.maybeNull(types.string),
      }),
    ),
    createdAt: '',
    createdBy: UserIdentifier,
    updatedAt: '',
    updatedBy: types.optional(UserIdentifier, {}),
    expiry: types.maybeNull(types.string),
  })
  .views(_self => ({
    get userTypes() {
      return ['admin', 'readonly'];
    },
  }));

export { NotebookPermissions };
